import React, { useState, useEffect } from "react";
import CommunityLayout from "../components/layouts/CommunityLayout";
import { usePageTitle } from '../hooks/usePageTitle';
import { useParams } from "react-router-dom";
import { CommunicationBoardOptions } from "../utils";

const CommunicationBoard = () => {
    usePageTitle('Communication Board - Wefayo');

    const { module } = useParams();
    const boardOption = CommunicationBoardOptions.find(option => option.module === module);
    const [isLoading, setIsLoading] = useState(true);

    // Reset loading state when module changes
    useEffect(() => {
        setIsLoading(true);
    }, [module]);

    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    return (
        <CommunityLayout currentPage={"cb"} onCommunitiesLoaded={()=>{}} isFullPageWidth={true} overflow={'overflow-y-hidden'}  >
            <div className="relative w-full md:w-[calc(100vw-250px)] h-[calc(100vh-80px)] md:mx-auto" style={{marginTop: "4rem"}}>
                {/* Loading Spinner */}
                {isLoading && (
                    <div className="absolute inset-0 flex flex-col items-center justify-center bg-white rounded-md z-10">
                        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mb-4"></div>
                        <p className="text-gray-600 text-lg font-medium">Loading {boardOption?.name || 'Communication Board'}...</p>
                        <p className="text-gray-400 text-sm mt-2">Please wait</p>
                    </div>
                )}
                
                {/* Iframe */}
                <iframe 
                    src={boardOption.url} 
                    className="w-full h-full"
                    style={{borderRadius: "5px"}} 
                    title={boardOption.name}
                    onLoad={handleIframeLoad}
                />
            </div>
        </CommunityLayout>
    );
};

export default CommunicationBoard;

